import React, { useState } from "react";
import { Modal, Button } from "antd";

const PackageCard = ({ currentAttendee }) => {
    const [isModalVisible, setIsModalVisible] = useState(false);

    const totalMeetings = currentAttendee?.allowed_meetings || 0;
    const completedMeetings = totalMeetings - (currentAttendee?.remaining_meetings || 0);
    const progress = totalMeetings > 0 ? Math.max(0, Math.min(100, (completedMeetings / totalMeetings) * 100)) : 0;

    let packageType = "Basic";
    let bgColor = "#D3D3D3";
    let borderColor = "#A9A9A9";
    let progressColor = "#A9A9A9";
    let progressBg = "#F5F5F5";

    if (currentAttendee?.package_type?.includes("silver")) {
        packageType = "Silver";
        bgColor = "#C0C0C0";
        borderColor = "#B0B0B0";
        progressColor = "#A8A8A8";
        progressBg = "#E0E0E0";
    } else if (currentAttendee?.package_type?.includes("gold")) {
        packageType = "Gold";
        bgColor = "#E3B027";
        borderColor = "#DAA520";
        progressColor = "#E6BE8A";
        progressBg = "#FCE79E";
    } else if (currentAttendee?.package_type?.includes("platinum")) {
        packageType = "Platinum";
        bgColor = "#E5E4E2";
        borderColor = "#B0C4DE";
        progressColor = "#B0C4DE";
        progressBg = "#D6D6D6";
    }

    // const totalMeetings = 10;
    // const completedMeetings = totalMeetings - currentAttendee?.allowed_meetings;
    // const progress = (completedMeetings / totalMeetings) * 100;

    // console.log("Current attendee===>", currentAttendee )

    const showModal = () => {
        setIsModalVisible(true);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    return (
        <>
            <div
                className="rounded-2xl p-6 w-full max-w-2xl shadow-lg relative border space-y-6 h-[12rem]"
                style={{ backgroundColor: bgColor, borderColor: borderColor }}
            >
                <h2 className="text-center text-lg font-semibold text-gray-900">
                    Your package is
                </h2>
                <h1 className="text-center text-3xl font-bold text-gray-900">
                    {packageType}
                </h1>

                <button
                    className="absolute top-25 right-4 bg-white text-gray-800 font-semibold px-4 py-2 rounded-lg shadow hover:bg-gray-50 transition-colors"
                    onClick={showModal}
                >
                    Update Package
                </button>
                {/* 
                <div className="mt-4 space-y-3">
                    <div className="w-full bg-gray-200 rounded-full h-9 p-1" style={{ backgroundColor: progressBg }}>
                        <div
                            className="h-full rounded-full transition-all flex items-center justify-center text-sm font-semibold"
                            style={{ 
                                width: `${progress > 0 ? progress : 3}%`,
                                backgroundColor: progressColor, 
                                color: progress === 100 ? "#fff" : "#000" 
                            }}
                        >
                        </div>
                    </div>

                    <div className="flex justify-between text-gray-900 text-sm font-semibold italic mt-1 px-2">
                        <span>{completedMeetings} out of {totalMeetings} meetings</span>
                        <span>Remaining {currentAttendee?.remaining_meetings || 0}</span>
                    </div>
                </div> */}
            </div>

            {/* Package Upgrade Modal */}
            <Modal
                title="Upgrade Your Package"
                open={isModalVisible}
                onCancel={handleCancel}
                footer={[

                ]}
                centered
            >
                <div className="py-4">
                    <div className="flex items-center justify-center mb-6">
                        <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-blue-500" viewBox="0 0 20 20" fill="currentColor">
                                <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                                <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                            </svg>
                        </div>
                    </div>

                    <h3 className="text-xl font-bold text-center mb-4">Contact Us to Upgrade</h3>
                    <p className="text-gray-600 text-center mb-4">
                        To upgrade your package and get more meetings, please contact our support team at:
                    </p>
                    <p className="text-blue-600 font-bold text-center text-lg mb-4">
                        sharjeel@agilefalconsg.com
                    </p>
                    <p className="text-gray-600 text-center">
                        Our team will assist you with the upgrade process and provide information about the benefits of each package.
                    </p>
                </div>
            </Modal>
        </>
    );
};

export default PackageCard;
